// What the purchase order screens need of the app besides the client and the user (app-kit's ViewerProvider): the
// words of the fields and values the issues of procurement name and the purchase orders do not, such as those of an
// inbound or of a code mapping (ADR-169). Registered once, like the client: issues and history are worded outside
// React.

export interface ProcurementTexts {
  /** A field the purchase orders do not name: its words, or undefined. */
  fieldText?: (field: string) => string | undefined;
  /** The value of an issue on such a field, where it is a code: its words, or undefined. */
  valueText?: (field: string, value: string) => string | undefined;
}

let registered: ProcurementTexts = {};

/** Optional: without it, a field the purchase orders do not name is shown as it is. */
export function registerProcurementTexts(texts: ProcurementTexts): void {
  registered = texts;
}

export const procurementTexts = (): ProcurementTexts => registered;
